export const SETTINGS_TAB_PARAM = 'tab';

export const SEATS_TAB = 'seats';
